'use client';

import { createContext } from 'react';

export interface SelectedMoment {
  playbackId: string;
  postId?: string;
  startTime: number;
  endTime: number;
  title?: string;
  thumbnailUrl?: string;
  momentType?: string;  // NEW: type of moment (testimonial, case_study, etc.)
  postTitle?: string;    // NEW: title of the video/post this moment comes from
  similarity?: number;   // NEW: similarity score from search
  previewUrl?: string;   // NEW: Rendi preview URL (for edited moments)
  isPreview?: boolean;   // NEW: Is this a Rendi preview?
  expiresAt?: string;    // NEW: Preview expiry time (ISO 8601)
  previewSessionId?: string; // NEW: Preview session ID for tracking
}

export interface Memo {
  id: string;
  user_id: string;
  domain_id: string;
  source_post_id: string;
  playbackId?: string | null;
  postTitle?: string | null;        // NEW: Source video title for display
  postCreatedAt?: string | null;    // NEW: Source video creation date for disambiguation
  title: string;
  source_timerange: {
    start: number;
    end: number;
  };
  edit_plan: {
    cuts: Array<{
      start: number;
      end: number;
      word?: string;
    }>;
    captions: Array<{
      findText: string;
      replaceWith: string;
    }>;
    audio: any | null;
  };
  status: 'draft' | 'exporting' | 'exported';
  rendi_job_id?: string | null;
  export_url?: string | null;
  created_at: string;
  updated_at: string;
  metadata?: {
    effective_duration?: number;
    [key: string]: any;
  };
}

export interface MomentoContextType {
  isOpen: boolean;
  open: () => void;
  close: () => void;
  toggle: () => void;
  currentPage: string;
  setCurrentPage: (page: string) => void;
  greeting: string;
  selectedMoment: SelectedMoment | null;
  setSelectedMoment: (moment: SelectedMoment | null) => void;
  activeMemo: Memo | null;
  setActiveMemo: (memo: Memo | null) => void;
  exitMemoMode: () => void;
}

export const MomentoContext = createContext<MomentoContextType | undefined>(undefined);
